import { GridColDef } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import dayjs from "dayjs";

/**
 * GenerateReinspecaoEmAbertoColumnDefinition
 */

type Props = {
  onRedirectToReinspecaoEmAberto: (idObra: number, idChecklistServico: number, idChecklistArea: number, idInspecaoObra: number, openNewTab: boolean) => void;
};

export const GenerateReinspecaoEmAbertoColumnDefinition = ({
  onRedirectToReinspecaoEmAberto,
}: Props): GridColDef[] => {

  return [
    {
      field: "descricaoArea",
      filterable: false,
      headerName: "Área",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: ({ value }) => {
        return (
          <div className="flex items-start break-normal py-2">
            <span>{value}</span>
          </div>
        );
      }
    },
    {
      field: "descricaoChecklistServico",
      filterable: false,
      headerName: "Checklist de Serviço",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: ({ value }) => {
        return (
          <div className="flex items-start break-normal py-2">
            <span>{value}</span>
          </div>
        );
      }
    },
    {
      field: "descricaoChecklistServicoAmbiente",
      filterable: false,
      headerName: "Ambiente",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: ({ value }) => {
        return (
          <div className="flex items-start break-normal py-2">
            <span>{value}</span>
          </div>
        );
      }
    },
    {
      field: "descricaoItem",
      filterable: false,
      headerName: "Item",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: ({ value }) => {
        return (
          <div className="flex items-start break-normal py-2">
            <span>{value}</span>
          </div>
        );
      }
    },
    {
      field: "dataInspecao",
      filterable: false,
      headerName: "Data Inspeção",
      flex: 1,
      minWidth: 150,
      sortable: false,
      headerClassName: 'funcionarios-header',
      renderCell: ({ value }) => {
        if (!value) return null;
        return <div className="flex items-center py-2"><span>{dayjs.utc(value).local().format('DD/MM/YYYY')}</span></div>;
      },
    },
    {
      field: "exportar",
      filterable: false,
      headerName: "Checklist",
      sortable: false,
      minWidth: 110,
      valueGetter: (_, row) => {
        return {
          idObra: row['idObra'],
          idChecklistServico: row['idChecklistServico'],
          idChecklistArea: row['idChecklistArea'],
          idInspecaoObra: row['idInspecaoObra']
        };
      },
      renderCell: ({ value }) => {
        return (
          <div className="flex items-start py-2">
            <Button
              onMouseDown={(e) => {
                if (e.button === 1) {
                  onRedirectToReinspecaoEmAberto(value.idObra, value.idChecklistArea, value.idChecklistServico, value.idInspecaoObra, true);
                } else {
                  onRedirectToReinspecaoEmAberto(value.idObra, value.idChecklistArea, value.idChecklistServico, value.idInspecaoObra, e.ctrlKey);
                }
                e.preventDefault();
              }}
              sx={{
                fontSize: 11,
                paddingX: '.4rem',
                paddingY: 0,
                background: '#e6e6e6',
                borderLeft: '.2rem solid #8e44ad',
                borderRadius: 0,
                color: 'black',
                fontWeight: 'normal',
              }}>
              Navegar
            </Button>
          </div>

        );
      },
    },
  ];
}
